export const debounce=(func,wait)=> {
  let timeout;
  return function executedFunction(...args) {
    const later=()=> {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout=setTimeout(later,wait);
  };
};

export const throttle=(func,limit)=> {
  let inThrottle;
  return function executedFunction(...args) {
    if (!inThrottle) {
      func.apply(this,args);
      inThrottle=true;
      setTimeout(()=> (inThrottle=false),limit);
    }
  };
};

export const preloadResources=()=> {
  const criticalImages=[ 
    'https://images.unsplash.com/photo-1504917595217-d4dc5f649776?w=1200',
    // Preload of the new hero image
    'https://media-manager-c.questera.ai/greta-media/32dc413054558dbd6d4d3c4a3e2032d0a5a88f3a3f9e6c5dd10a15135c65ae90de62d22e50b183c419625584e3716ff8/images/aW1hZ2UvcG5n/af96fef325f049547c6c253baaaf1c7c.png' 
  ];
  
  criticalImages.forEach(src=> {
    const link=document.createElement('link');
    link.rel='preload';
    link.as='image';
    link.href=src;
    document.head.appendChild(link);
  });
  
  const domains=[ 
    'https://images.unsplash.com',
    'https://nominatim.openstreetmap.org' 
  ];
  
  domains.forEach(domain=> {
    const link=document.createElement('link');
    link.rel='preconnect';
    link.href=domain;
    link.crossOrigin='anonymous';
    document.head.appendChild(link);
  });
};